import { DatePicker, Space, Table, message, Spin, Form, Image, Tooltip, Button, Radio } from 'antd';
import dayjs from 'dayjs';
import { FileExcelOutlined } from '@ant-design/icons';
import constants from '../../constants/constants';
import { useContext, useEffect, useState } from 'react';
import debounce from 'lodash/debounce';
import WebLinks from '../../api/WebLinks';
import Cookies from 'js-cookie';
import * as XLSX from "xlsx";
import APIUtils from '../../api/APIUtils';
import { useHistory } from 'react-router-dom';
import { CommonContext } from '../../Context';
const { RangePicker } = DatePicker;

const AppScore = (props) => {
  const [appScoreData, setAppScoreData] = useState([]);
  const [rangePickerValue, setRangePickerValue] = useState([]);
  const [loader, setLoader] = useState(false);
  const [viewType, setViewType] = useState('supplier');
  const [form] = Form.useForm();
  const history = useHistory();
  const commonContext=useContext(CommonContext);
  const buyerId = commonContext.common.buyerId;

  useEffect(() => {
    const savedFilters = JSON.parse(sessionStorage.getItem('appScoreFilters') || '{}');
    if (
      savedFilters.rangePickerValue?.length === 2 && savedFilters.viewType
    ) {
      const date1 = dayjs(savedFilters.rangePickerValue[0],constants.DateFormat2);
      const date2 = dayjs(savedFilters.rangePickerValue[1],constants.DateFormat2);
      form.setFieldsValue({rangePicker: [date1, date2],});
      setRangePickerValue(savedFilters.rangePickerValue);
      setViewType(savedFilters.viewType);
      GetAppScoreData(
        savedFilters.viewType,
        savedFilters.rangePickerValue[0],
        savedFilters.rangePickerValue[1]
      );
    } else {
      const date1 = dayjs().startOf('month');
      const date2 = dayjs().endOf('day');
      form.setFieldsValue({rangePicker: [date1, date2]});
      setRangePickerValue([
        date1.format(constants.DateFormat2),
        date2.format(constants.DateFormat2),
      ]);
      GetAppScoreData(
        'supplier',
        date1.format(constants.DateFormat2),
        date2.format(constants.DateFormat2)
      );
    }
  }, []);

  //Function to handle quality count click and navigate to appscore-applications
  const redirectToAppScoreApplications = (record, scoreValue) => {
    sessionStorage.setItem(
      'appScoreFilters',
      JSON.stringify({
        rangePickerValue,
        viewType,
      })
    );
    sessionStorage.setItem('keepApplicationReportTab', 'true');
    history.push({
      pathname: '/appscores-applications',
      state: {
        record,
        scoreValue,
        startDate: rangePickerValue[0],
        endDate: rangePickerValue[1],
        viewType,
      },
    });
  };
  const getScoreDisplay = (score, totalApplications) => {
    if (!score || score <= 0) {
      return '0';
    }
    const percentage = Math.round((score / totalApplications) * 100);
    return `${score} (${percentage}%)`;
  };
  const getPercentage = (count, total) => {
    if (!count || !total) return 0;
    return Math.round((count / total) * 100);
  };
  const getHighlightClass = (type, record) => {
    if (type === "avg") {
      return record.avgScore >= 5
        ? "inline-flex h-9 w-20 items-center justify-center border-4 border-lime-500 rounded-lg"
        : "inline-flex h-9 w-20 items-center justify-center";
    }
    const percentage = getPercentage(
      record[`score${type}`],
      record.totalApplications
    );
    // Scores 7-10 -> Green
    if (type >= 7) {
      return percentage >= 10
        ? "flex h-9 w-20 items-center justify-center box-border rounded-lg border-4 border-lime-500"
        : "flex h-9 w-20 items-center justify-center";
    }
    // Scores 1-5 -> Orange
    if (type <= 5) {
      return percentage >= 10
        ? "flex h-9 w-20 items-center justify-center box-border rounded-lg border-4 border-orange-500"
        : "flex h-9 w-20 items-center justify-center";
    }
    // Score 6 -> No highlight
    return "flex h-9 w-20 items-center justify-center";
  };
  const columns = [
    {
      title: `${viewType === 'supplier' ? 'Supplier' : 'Occupation'}`,
      key: viewType === 'supplier' ? 'displayName' : 'occupation',
      fixed: 'left',
      width: 140,
      sorter: (a, b) => {
        const field = viewType === 'supplier' ? 'displayName' : 'occupation';
        return (a[field] || '').localeCompare(b[field] || '');
      },
      render: (_, record) => {
        if (viewType !== 'supplier') {
          return record.occupation;
        }
        return record?.logoURL ? (
          <Image
            src={record.logoURL}
            preview={false}
            width={100}
          />
        ) : (
          <span>{record?.displayName}</span>
        );
      },
    },
    {
      title: 'Avg',
      dataIndex: 'avgScore',
      key: 'avgScore',
      align: 'center',
      sorter: (a, b) => (a?.avgScore ?? 0) - (b?.avgScore ?? 0),
      render: (_, record) => (
        <div className="flex justify-center">
          <span className={getHighlightClass("avg", record)}>
            {record.avgScore ?? "NULL"}
          </span>
        </div>
      ),
    },
    {
      title: '10',
      dataIndex: 'score10',
      key: 'score10',
      align: 'center',
      sorter: (a, b) => (a?.score10 ?? 0) - (b?.score10 ?? 0),
      render: (_, record) => (
        <div className="flex justify-center">
          {record.score10 > 0 ? (
            <Button
              type="link"
              className="!p-0"
              onClick={() => redirectToAppScoreApplications(record, 10)}
            >
              <span className={getHighlightClass(10, record)}>
                {getScoreDisplay(record.score10, record.totalApplications)}
              </span>
            </Button>
          ) : (
            <span>0</span>
          )}
        </div>
      ),
    },
    {
      title: '9',
      dataIndex: 'score9',
      key: 'score9',
      align: 'center',
      sorter: (a, b) => (a?.score9 ?? 0) - (b?.score9 ?? 0),
      render: (_, record) => (
        <div className="flex justify-center">
          {record.score9 > 0 ? (
            <Button
              type="link"
              className="!p-0"
              onClick={() => redirectToAppScoreApplications(record, 9)}
            >
              <span className={getHighlightClass(9, record)}>
                {getScoreDisplay(record.score9, record.totalApplications)}
              </span>
            </Button>
          ) : (
            <span>0</span>
          )}
        </div>
      ),
    },
    {
      title: '8',
      dataIndex: 'score8',
      key: 'score8',
      align: 'center',
      sorter: (a, b) => (a?.score8 ?? 0) - (b?.score8 ?? 0),
      render: (_, record) => (
        <div className="flex justify-center">
          {record.score8 > 0 ? (
            <Button
              type="link"
              className="!p-0"
              onClick={() => redirectToAppScoreApplications(record, 8)}
            >
              <span className={getHighlightClass(8, record)}>
                {getScoreDisplay(record.score8, record.totalApplications)}
              </span>
            </Button>
          ) : (
            <span>0</span>
          )}
        </div>
      ),
    },
    {
      title: '7',
      dataIndex: 'score7',
      key: 'score7',
      align: 'center',
      sorter: (a, b) => (a?.score7 ?? 0) - (b?.score7 ?? 0),
      render: (_, record) => (
        <div className="flex justify-center">
          {record.score7 > 0 ? (
            <Button
              type="link"
              className="!p-0"
              onClick={() => redirectToAppScoreApplications(record, 7)}
            >
              <span className={getHighlightClass(7, record)}>
                {getScoreDisplay(record.score7, record.totalApplications)}
              </span>
            </Button>
          ) : (
            <span>0</span>
          )}
        </div>
      ),
    },
    {
      title: '6',
      dataIndex: 'score6',
      key: 'score6',
      align: 'center',
      sorter: (a, b) => (a?.score6 ?? 0) - (b?.score6 ?? 0),
      render: (_, record) => (
        <div className="flex justify-center">
          {record?.score6 > 0 ? (
            <Button
              type="link"
              className="!p-0"
              onClick={() => redirectToAppScoreApplications(record, 6)}
            >
              <span className={getHighlightClass(6, record)}>
                {getScoreDisplay(record.score6, record.totalApplications)}
              </span>
            </Button>
          ) : (
            <span>0</span>
          )}
        </div>
      ),
    },
    {
      title: '5',
      dataIndex: 'score5',
      key: 'score5',
      align: 'center',
      sorter: (a, b) => (a?.score5 ?? 0) - (b?.score5 ?? 0),
      render: (_, record) => (
        <div className="flex justify-center">
          {record?.score5 > 0 ? (
            <Button
              type="link"
              className="!p-0"
              onClick={() => redirectToAppScoreApplications(record, 5)}
            >
              <span className={getHighlightClass(5, record)}>
                {getScoreDisplay(record.score5, record.totalApplications)}
              </span>
            </Button>
          ) : (
            <span>0</span>
          )}
        </div>
      ),
    },
    {
      title: '4',
      dataIndex: 'score4',
      key: 'score4',
      align: 'center',
      sorter: (a, b) => (a?.score4 ?? 0) - (b?.score4 ?? 0),
      render: (_, record) => (
        <div className="flex justify-center">
          {record?.score4 > 0 ? (
            <Button
              type="link"
              className="!p-0"
              onClick={() => redirectToAppScoreApplications(record, 4)}
            >
              <span className={getHighlightClass(4, record)}>
                {getScoreDisplay(record.score4, record.totalApplications)}
              </span>
            </Button>
          ) : (
            <span>0</span>
          )}
        </div>
      ),
    },
    {
      title: '3',
      dataIndex: 'score3',
      key: 'score3',
      align: 'center',
      sorter: (a, b) => (a?.score3 ?? 0) - (b?.score3 ?? 0),
      render: (_, record) => (
        <div className="flex justify-center">
          {record?.score3 > 0 ? (
            <Button
              type="link"
              className="!p-0"
              onClick={() => redirectToAppScoreApplications(record, 3)}
            >
              <span className={getHighlightClass(3, record)}>
                {getScoreDisplay(record.score3, record.totalApplications)}
              </span>
            </Button>
          ) : (
            <span>0</span>
          )}
        </div>
      ),
    },
    {
      title: '2',
      dataIndex: 'score2',
      key: 'score2',
      align: 'center',
      sorter: (a, b) => (a?.score2 ?? 0) - (b?.score2 ?? 0),
      render: (_, record) => (
        <div className="flex justify-center">
          {record?.score2 > 0 ? (
            <Button
              type="link"
              className="!p-0"
              onClick={() => redirectToAppScoreApplications(record, 2)}
            >
              <span className={getHighlightClass(2, record)}>
                {getScoreDisplay(record.score2, record.totalApplications)}
              </span>
            </Button>
          ) : (
            <span>0</span>
          )}
        </div>
      ),
    },
    {
      title: '1',
      dataIndex: 'score1',
      key: 'score1',
      align: 'center',
      sorter: (a, b) => (a?.score1 ?? 0) - (b?.score1 ?? 0),
      render: (_, record) => (
        <div className="flex justify-center">
          {record?.score1 > 0 ? (
            <Button
              type="link"
              className="!p-0"
              onClick={() => redirectToAppScoreApplications(record, 1)}
            >
              <span className={getHighlightClass(1, record)}>
                {getScoreDisplay(record.score1, record.totalApplications)}
              </span>
            </Button>
          ) : (
            <span>0</span>
          )}
        </div>
      ),
    },
    {
      title: 'Not GAP',
      dataIndex: 'notScored',
      key: 'notScored',
      align: 'center',
      sorter: (a, b) => (a?.notScored ?? 0) - (b?.notScored ?? 0),
    },
    {
      title: 'Total Applications',
      dataIndex: 'totalApplications',
      key: 'totalApplications',
      width: "9%",
      align: 'center',
      sorter: (a, b) => (a?.totalApplications ?? 0) - (b?.totalApplications ?? 0),
    },
  ];
  //Function runs when range picker value is changed
  const RangePickerChanged = debounce((_, dateStrings) => {
    setRangePickerValue([
      dateStrings[0],
      dateStrings[1],
    ]);
    sessionStorage.setItem(
      'appScoreFilters',
      JSON.stringify({
        rangePickerValue: dateStrings,
        viewType,
      })
    );
    GetAppScoreData(viewType, dateStrings[0], dateStrings[1]);
  }, 500);

  //Function to Month report data
  const GetAppScoreData = async (viewType, startDate, endDate) => {
    setLoader(true);

    const url = viewType === 'supplier' ? WebLinks.GetGAPAnalysisBySupplier : WebLinks.GetGAPAnalysisByOccupation;
    const response = await APIUtils.apiCall('GET', url + buyerId+ "&dateFrom=" + startDate + "&dateTo=" + endDate);
    if (!response.isCatch && response.resultObj.statusCode === "2000") {
      setAppScoreData(response.resultObj.data);
      setLoader(false);
    } else {
      setAppScoreData([]);
      setLoader(false);
      message.error(response.resultObj.message);
    }
  }
  //Function to download as excel
  const downloadFile = () => {
    try {
      if (!appScoreData || appScoreData.length === 0) {
        message.error("No data to download");
        return;
      }
      setLoader(true);
      const excelData = appScoreData.map((item) => ({
        [viewType === 'supplier' ? 'Supplier' : 'Occupation']:
          viewType === 'supplier'
            ? item.displayName
            : item.occupation,
        "Avg Score": item.avgScore ?? 0,
        "Score 10": item.score10 ?? 0,
        "Score 9": item.score9 ?? 0,
        "Score 8": item.score8 ?? 0,
        "Score 7": item.score7 ?? 0,
        "Score 6": item.score6 ?? 0,
        "Score 5": item.score5 ?? 0,
        "Score 4": item.score4 ?? 0,
        "Score 3": item.score3 ?? 0,
        "Score 2": item.score2 ?? 0,
        "Score 1": item.score1 ?? 0,
        "Not Scored": item.notScored ?? 0,
        "Total Applications": item.totalApplications ?? 0,
      }));
      const worksheet = XLSX.utils.json_to_sheet(excelData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        viewType === 'supplier' ? 'Supplier' : 'Occupation'
      );
      const fileName =
        `${viewType === 'supplier' ? 'Supplier' : 'Occupation'} App Score ` +
        `${rangePickerValue[0]} - ${rangePickerValue[1]}.xlsx`;

      setTimeout(() => {
        XLSX.writeFile(workbook, fileName);
        setLoader(false);
      }, 300);
    } catch (err) {
        setLoader(false);
        message.error("Error downloading file");
    }
  };

  const onViewTypeChange = (e) => {
    const value = e.target.value;
    sessionStorage.setItem(
      'appScoreFilters',
      JSON.stringify({
        rangePickerValue,
        viewType: value,
      })
    );
    setViewType(value);
    GetAppScoreData(
      value,
      rangePickerValue[0],
      rangePickerValue[1],
    );
  };
  return (
    <Spin spinning={loader}>
        <div className='flex flex-wrap gap-3 justify-between items-center mb-3'>
          <div className='flex flex-wrap items-center gap-3'>
            <Form form={form}>
              <Form.Item name="rangePicker" className='mb-0'>
                <RangePicker
                  placeholder={["From", "To"]}
                  onChange={RangePickerChanged}
                  format={constants.DateFormat2}
                  disabledDate={(current) =>
                    current && current > dayjs().endOf('day')
                  }
                />
              </Form.Item>
            </Form>
            <Radio.Group
              value={viewType}
              onChange={onViewTypeChange}
              optionType="button"
              buttonStyle="solid"
              className="custom-radio-group"
            >
              <Radio.Button value="supplier">
                Supplier
              </Radio.Button>
              <Radio.Button value="occupation">
                Occupation
              </Radio.Button>
            </Radio.Group>
          </div>
          <Tooltip placement='right' title="Download as Excel">
            <Button
              className='bg-green-800 text-white hover:!text-white hover:!border-green-500'
              icon={<FileExcelOutlined />}
              onClick={downloadFile}
            >
              Download as Excel
            </Button>
          </Tooltip>
        </div>
        <div className='overflow-x-auto'>
          <Table
            columns={columns}
            dataSource={appScoreData}
            scroll={{x: 1500}}
            sortDirections={['descend', 'ascend']}
            pagination={false}
          />
        </div>
    </Spin>
  );
};
export default AppScore;